import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import Form from "react-bootstrap/Form";

export function OptionProductSetBranch() {
  const product = useSelector((state) => state.product.product);

  const bundleItems = useMemo(() => {
    if (!product?.productBundleItemsAsBundle?.length) {
      return [];
    }

    return product.productBundleItemsAsBundle.map((item) => ({
      id: item.id,
      productName: item.componentProduct?.name || "-",
      productSku: item.componentProduct?.sku || "",
      quantity: item.quantity ?? 1,
      unitPrice:
        item.unit_price != null
          ? Number(item.unit_price)
          : Number(item.componentProduct?.price) || 0,
    }));
  }, [product]);

  const sumQuantity = bundleItems.reduce(
    (acc, item) => acc + (parseInt(item.quantity, 10) || 0),
    0
  );

  const sumPrice = bundleItems.reduce(
    (acc, item) =>
      acc + item.unitPrice * (parseInt(item.quantity, 10) || 0),
    0
  );

  return (
    <div className="card card-st-3 mb-3">
      <div className="card-body px-xl-3">
        <div className="pt-2 pb-1 px-3">
          <span className="fw-medium" style={{ color: "#FF731D" }}>
            ตัวเลือกสินค้าจัดชุด
          </span>
          <span className="ms-2" style={{ color: "#858796" }}>
            (รายการสินค้าในชุดที่กำหนดจากระดับธุรกิจ)
          </span>
        </div>

        <div className="px-5 py-4">
          {bundleItems.length === 0 ? (
            <div className="px-3 text-secondary">
              ยังไม่มีรายการสินค้าในชุด
            </div>
          ) : (
            <div className="mt-2 ps-2">
              {bundleItems.map((item) => (
                <div className="row gx-4 align-items-center mb-3" key={item.id}>
                  <div className="col">
                    <Form.Group className="mb-2 form-st-3 pb-1">
                      <Form.Label className="mb-1">ชื่อสินค้า</Form.Label>
                      <Form.Control
                        type="text"
                        value={
                          item.productSku
                            ? `${item.productSku} - ${item.productName}`
                            : item.productName
                        }
                        disabled
                      />
                    </Form.Group>
                  </div>
                  <div className="col-auto">
                    <Form.Group
                      className="mb-2 form-st-3 pb-1"
                      style={{ width: "150px" }}
                    >
                      <Form.Label className="mb-1">จำนวน</Form.Label>
                      <Form.Control
                        type="text"
                        value={item.quantity}
                        disabled
                      />
                    </Form.Group>
                  </div>
                  <div className="col-auto">
                    <Form.Group
                      className="mb-2 form-st-3 pb-1"
                      style={{ width: "150px" }}
                    >
                      <Form.Label className="mb-1">ราคาขาย</Form.Label>
                      <Form.Control
                        type="text"
                        value={item.unitPrice.toFixed(2)}
                        disabled
                      />
                    </Form.Group>
                  </div>
                  <div className="col-auto">
                    <Form.Group
                      className="mb-2 form-st-3 pb-1"
                      style={{ width: "150px" }}
                    >
                      <Form.Label className="mb-1">ราคารวม</Form.Label>
                      <Form.Control
                        type="text"
                        value={(
                          item.unitPrice * (parseInt(item.quantity, 10) || 0)
                        ).toFixed(2)}
                        disabled
                      />
                    </Form.Group>
                  </div>
                </div>
              ))}

              <div className="row gx-4 align-items-center">
                <div className="col" />
                <div className="col-auto">
                  <Form.Group
                    className="mb-2 form-st-3 pb-1"
                    style={{ width: "150px" }}
                  >
                    <Form.Label className="mb-1">จำนวนรวม</Form.Label>
                    <Form.Control type="text" value={sumQuantity} disabled />
                  </Form.Group>
                </div>
                <div className="col-auto">
                  <div style={{ width: "150px" }} />
                </div>
                <div className="col-auto">
                  <Form.Group
                    className="mb-2 form-st-3 pb-1"
                    style={{ width: "150px" }}
                  >
                    <Form.Label className="mb-1">ราคารวมทั้งหมด</Form.Label>
                    <Form.Control
                      type="text"
                      value={sumPrice.toFixed(2)}
                      disabled
                    />
                  </Form.Group>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default OptionProductSetBranch;
